import { defaultClient } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const get = (deliveryId) =>
  defaultClient({
    method: 'GET',
    baseURL,
    url: `/delivery-order/${deliveryId}/activity`,
  })
